import { render, staticRenderFns } from "./start.vue?vue&type=template&id=477783b6&scoped=true"
import script from "./start.vue?vue&type=script&lang=js"
export * from "./start.vue?vue&type=script&lang=js"
import style0 from "./start.vue?vue&type=style&index=0&id=477783b6&prod&lang=less&scoped=true"
import style1 from "./start.vue?vue&type=style&index=1&id=477783b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477783b6",
  null
  
)

export default component.exports